<div class="bg-transparent page-height overflow-auto">
  @if (isLoading) {
  <app-loading-spinner [text]="'Negotiations'"></app-loading-spinner>
  }
  <div
    class="py-2 px-4 flex flex-col items-center justify-center mx-auto max-w-xl"
  >
    @if (userData$ | async; as user) {
    <div class="w-full flex flex-col gap-3">
      <mat-card class="my-3">
        <mat-card-header class="w-full" style="width: 100% !important">
          <mat-card-title>
            <div class="w-full flex flex-row items-center justify-start gap-3">
              <span>
                {{ user.first_name + " " + user.last_name }}
              </span>
              <span>
                <mat-chip class="text-xs text-white orange-chip">
                  {{ user.role | titlecase }}
                </mat-chip>
              </span>
            </div>
          </mat-card-title>
          <mat-card-subtitle
            class="text-sm tablet-min:text-base text-blue-500 font-normal"
          >
            {{ user.email }}
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content></mat-card-content>
      </mat-card>
      <app-default-commodity-autocomplete></app-default-commodity-autocomplete>
      <a routerLink="my-bids-and-offers">
        <mat-card matRipple class="pb-3">
          <mat-card-header> My Bids & Offers </mat-card-header>
        </mat-card>
      </a>
      <a routerLink="/app/contracts">
        <mat-card matRipple class="pb-3">
          <mat-card-header> Contracts </mat-card-header>
        </mat-card>
      </a>
      <mat-card
        matRipple
        class="hover:cursor-pointer pb-3"
        (click)="openContactUsForm()"
      >
        <mat-card-header>Contact Us</mat-card-header>
      </mat-card>
      <a routerLink="/app/faqs">
        <mat-card matRipple class="pb-3">
          <mat-card-header> FAQ </mat-card-header>
        </mat-card>
      </a>
      <app-notification-preferences class="my-5" />
      <div class="flex flex-col gap-2 my-5 text-base">
        <a routerLink="/forgot-password">
          <mat-card matRipple class="pb-3">
            <mat-card-header>Forgot Password</mat-card-header>
          </mat-card>
        </a>
        <mat-card
          matRipple
          class="pb-3 h-full hover:cursor-pointer"
          (click)="logout()"
        >
          <mat-card-header class="" [ngStyle]="{ color: 'rgb(255 169 47)' }">
            Sign Out
          </mat-card-header>
        </mat-card>
      </div>
    </div>
    }
    <div
      class="justify-self-end self-end m-3 p-3 text-center text-sm tablet-max:text-sm"
    >
      <p class="text-gray-400 mx-auto">
        By utilizing this application, you consent to adhere to our
        <a [href]="links.termsOfService" target="_blank" class="text-orange-300"
          >terms of use</a
        >
        and
        <a
          [href]="links.privacyPolicy"
          class="text-orange-300"
          target="_blank"
          text-orange-300
          >privacy policy</a
        >
      </p>
      <span class="opacity-10 position-absolute">V1.10.1</span>
    </div>
  </div>
</div>
